const initialState = [];

function deviceBrandsReducer(state = initialState, action) {
  switch (action.type) {
    case "deviceBrands/update":
      return action.payload;
    case "deviceBrands/delete":
      return state.filter(
        (deviceBrand) => !action.payload.includes(deviceBrand.id)
      );
    default:
      return state;
  }
}

export default deviceBrandsReducer;
